import React from 'react';
import { motion } from 'framer-motion';
import { FRAMEWORK_STEPS } from '../data/site';
export function FrameworkTimeline() {
  return <ol className="relative" data-id="element-73">
      {/* vertical spine */}
      <span className="absolute left-[1.35rem] top-2 bottom-2 w-px bg-stone-200 md:left-1/2" aria-hidden="true" data-id="element-74" />
      {FRAMEWORK_STEPS.map((step, i) => {
      const left = i % 2 === 0;
      return <li key={step.number} className="relative" data-id="element-75">
            <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: 0.05
        }} className={`md:grid md:grid-cols-2 md:gap-16 items-center py-6 md:py-10`} data-id="element-76">
              <div className={`pl-16 md:pl-0 ${left ? 'md:pr-16 md:text-right' : 'md:col-start-2 md:pl-16'}`} data-id="element-77">
                <p className="eyebrow text-trust-600 mb-2" data-id="element-78">
                  Step {step.number}
                </p>
                <h3 className="font-serif text-2xl md:text-3xl tracking-tightest text-ink" style={{
              fontWeight: 500
            }} data-id="element-79">
                  {step.title}
                </h3>
                <p className="mt-3 text-stone-600 leading-relaxed max-w-md md:inline-block" data-id="element-80">
                  {step.description}
                </p>
              </div>

              {/* node */}
              <span className="absolute left-[1.35rem] md:left-1/2 top-8 md:top-1/2 -translate-x-1/2 md:-translate-y-1/2 flex h-11 w-11 items-center justify-center rounded-full bg-ink text-paper font-serif text-sm shadow-sm" style={{
            fontWeight: 600
          }} aria-hidden="true" data-id="element-81">
                {step.number}
              </span>
            </motion.div>
          </li>;
    })}
    </ol>;
}